import React, { useState } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import '../styles/layout.css';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="workspace">
      <Topbar user={user} onLogout={logout} onMenuClick={toggleSidebar} />
      <div className="workspace-container">
        <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} onNavClick={closeSidebar} />
        {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
        <main className="workspace-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
